// import IEventProcessor from 'screens/gameplay/eventProcessor/IEventProcessor'
// import { getZupeeUserId } from 'store/selectors/user'
// import { getMySeatIndex, getTotalPlayers } from 'screens/gameplay/store/selectors'
// import { PLAYER_NUMBER } from 'screens/gameplay/types'
import _isNil from 'lodash/isNil'
// import { getPlayerNumberForSeatIndex } from 'screens/gameplay/utils'
// import store from 'store'
// import { setPlayerSiMap } from 'screens/gameplay/store/actions'
// import IEventProcessor from './IEventProcessor'
// import { getZupeeUserId } from '../../store/selectors/user'
// import { store } from '../../store'
// import { PLAYER_NUMBER } from './types'
import IEventProcessor from './IEventProcessor'
import { store } from '../../../store'
import { PLAYER_NUMBER } from '../types'
import { getMySeatIndex, getTotalPlayers } from '../../../store/selectors/ludoboardSelectors'
import { setPlayerSiMap } from '../../../store/actions/ludoboardActions'
import { getPlayerNumberForSeatIndex } from '../../../utils/helpers/TournamentNXUtils'

const { getState } = store
export default class BaseEventProcessor implements IEventProcessor {
  handleOtherPlayerTokenClick(playerNumber: PLAYER_NUMBER, score: number): void {
    throw new Error('Method not implemented.')
  }
  handleMoveTokenClick(tokenIndex: number): void {
    // throw new Error('Method not implemented.')
  }
  handleUserTimerSounds(timeLeft: number, totalTurnTime: number, percentageToStartSoundAt?: number): void {
    throw new Error('Method not implemented.')
  }
  cancelUserTimerSounds(): void {
    throw new Error('Method not implemented.')
  }
  handleUserTurnEnded(): void {
    throw new Error('Method not implemented.')
  }
  processGameTableInfo(tableInfo: any) {}
  processJoinTable(data: any) {}
  processRoundTimerStarted() {}
  processCollectBootValue() {}
  processUserTurnStarted(data: any) {}
  processTurnUserTimeout(data: any, disconnectCount: number) {}
  processAnimateDice(eventType: 'click' | 'socket') {}
  processLeaveTable(data: any) {}
  processWinnerDeclared(data: any) {}
  processLastMove(data: any) {}
  processMoveUserKukari(data: any) {}
  finishKillUserToken(initialPosition: number) {}
  finishMoveUserToken(initialPosition: number) {}
  processTimeBankLeft(data: any) {}
  activateTimeBankCounter() {}
  deActivateTimeBankCounter() {}
  clearAllTimeoutsAndIntervals() {}
  // handleOtherPlayerTokenClick(playerNumber: PLAYER_NUMBER, score: number) {}
  handleCoinAnimationEnd() {}
  parsePlayerSiMap(si: number, zuid: number, selfSi?: number, ms?: number) {
    // const myZuid = getZupeeUserId(getState())
    const myZuid = 164007819437377
    const totalPlayers = ms || getTotalPlayers(getState())
    const mySeatIndex = !_isNil(selfSi) ? selfSi : getMySeatIndex(getState())

    // Ideally we receive JT event for self first then GTI and then JT for other users
    // it will run very first time and then from next JT else it will run

    if (zuid === myZuid) {
      setPlayerSiMap(PLAYER_NUMBER.ONE, si)
    } else if (!_isNil(mySeatIndex) && !_isNil(totalPlayers)) {
      setPlayerSiMap(getPlayerNumberForSeatIndex(totalPlayers, mySeatIndex, si), si)
    }
  }
}
